<template>
  <div>
    <b-row id="g-main-image" class="mb-5">
      <b-col sm="2">
        <label>
          <h5>
            {{ $t("PAGE.CAMPAIGN.FORM.FIELDS.LANDING_IMAGE") }}
          </h5>
        </label>
      </b-col>
      <b-col sm="10">
        <b-form-file
          v-model="form.new_landing_image"
          accept="image/*"
          :placeholder="this.$t('PAGE.DEFAULT.FORM.PLACEHOLDER.CHOOSE_IMAGE')"
        ></b-form-file>
        <p v-if="isSubmit && !form.new_landing_image" class="text-danger">
          {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
        </p>
        <div class="pt-2">
          <img
            class="preview-image"
            v-if="form.new_landing_image"
            :src="previewImage(form.new_landing_image)"
          />
          <img
            class="preview-image"
            v-if="!form.new_landing_image && form.landing_image"
            :src="`${ADMIN_IMAGE_URL}/${form.landing_image}`"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<style scoped>
.preview-image {
  height: 667px;
  max-width: 375px;
  object-fit: cover;
}

@media only screen and (max-width: 460px) {
  .preview-image {
    max-width: 100%;
  }
}
</style>
<script>
import { Config } from "@/core/config/variable.config";

export default {
  name: "Campaignlanding",
  props: ["form", "isSubmit"],
  data() {
    return {
      ADMIN_IMAGE_URL: Config.ADMIN_IMAGE_URL
    };
  },
  methods: {
    previewImage(file) {
      return window.URL.createObjectURL(file);
    }
  }
};
</script>
